export default {
  name: 'Celluna',
  domain: 'celluna',
  id: '6554d46307eb5be501d31e7f',
  slug: 'celluna',
  path: '/celluna/',
  logo: '/partners/celluna/img/logo.png',
  themes: {
    light: {
      primary: '#809b3d',
      secondary: '#3d549b',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#3d549b',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
